import { useTranslation } from 'react-i18next';

import { PageContainer } from '../../../../components/molecules/page-container';
import { PageHeader } from '../../../../components/molecules/page-header';
import { CreateDestinationForm } from '../organisms/create-destination/create-destination-form';

import Loader from '@/components/atoms/loader/loader';
import { useOrganizationKiosks } from '@/features/shared/hooks/query/use-organization-kiosks';
import { withPermissions } from '@/permissions/can';

const CreateDestination = () => {
  const { t } = useTranslation(['createDestination']);
  const { data: organizationKiosks } = useOrganizationKiosks();
  const hasOrganizationKiosk = organizationKiosks && organizationKiosks.length > 0;

  return (
    <PageContainer helmetPageTitle={t('createDestination:tab')}>
      <PageHeader title={t('createDestination:title')} />
      {/* Show loader while checking if organization has kiosks, to initialize xstate machine with correct initial state */}
      {hasOrganizationKiosk === undefined ? (
        <Loader />
      ) : (
        <CreateDestinationForm hasOrganizationKiosk={hasOrganizationKiosk} />
      )}
    </PageContainer>
  );
};

export default withPermissions(
  permissions => permissions.cannot('create', 'Destinations'),
  CreateDestination,
);
